import React, { useMemo, useRef } from 'react'
import { useFormik } from 'formik'
import { Toast } from 'primereact/toast'
import employeeService from '../../../services/data/employee.service'
import checkCPFouCNPJ from '../../../helpers/checkCPFouCNPJ'
import UserPersonalDataFields, { userBirthdayForInput } from './userPersonalDataFields'

export default function FormEmployeePersonalData({ employee, onSaved }) {
    const toast = useRef(null)
    const user = employee?.user

    const initialValues = useMemo(
        () => ({
            legalId: user?.legalId || '',
            birthday: userBirthdayForInput(user),
            born_sex: user?.born_sex || '',
            gender: user?.gender !== undefined && user?.gender !== null ? String(user.gender) : '',
        }),
        [user]
    )

    const formik = useFormik({
        enableReinitialize: true,
        initialValues,
        validate: values => {
            const errors = {}
            const digits = (values.legalId || '').replace(/\D/g, '')
            if (digits.length > 0 && digits.length !== 11) {
                errors.legalId = 'CPF deve ter 11 dígitos'
            } else if (digits.length === 11 && !checkCPFouCNPJ(values.legalId)) {
                errors.legalId = 'CPF inválido'
            }
            if (!values.birthday) errors.birthday = 'Obrigatório'
            if (!values.born_sex) errors.born_sex = 'Obrigatório'
            if (values.gender === '' || values.gender === null || values.gender === undefined) {
                errors.gender = 'Obrigatório'
            }
            return errors
        },
        onSubmit: values => {
            const payload = {
                company_id: localStorage.getItem('companyId'),
                id: employee.id,
                legalId: values.legalId,
                birthday: values.birthday,
                born_sex: values.born_sex,
                gender: parseInt(values.gender, 10),
            }
            employeeService
                .updateEmployee(payload)
                .then(() => {
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Sucesso',
                        detail: 'Dados pessoais atualizados.',
                        life: 4000,
                    })
                    if (typeof onSaved === 'function') onSaved()
                })
                .catch(err => {
                    const detail = err?.response?.data
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Ops',
                        detail: typeof detail === 'string' ? detail : JSON.stringify(detail || err),
                        life: 5000,
                    })
                })
        },
    })

    if (!employee || !user) return null

    return (
        <form className="g-2 py-3" onSubmit={formik.handleSubmit}>
            <Toast ref={toast} position="top-right" />
            <p className="text-muted small">
                CPF, data de nascimento, sexo de nascimento e gênero. Alterações em outro colaborador exigem permissão{' '}
                <strong>change_employee</strong> ou perfil de dono da empresa.
            </p>
            <UserPersonalDataFields formik={formik} />

            <div className="btnMargin mt-4">
                <button className="btn btn-success btn-sm btn-rounded px-4" type="submit">
                    Salvar dados pessoais
                </button>
            </div>
        </form>
    )
}
